import * as React from 'react';
import { useThemeParams } from '@vkruglikov/react-telegram-web-app';
import { TomoProviderProps, TomoProvider, useTomo } from './TomoContext';
import { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { TonProvider } from './v2/types/types';
import type { EthereumProvider } from './v2/provider/EthereumProvider/EthereumProvider';

type OnConnectType = 'TON'|'SOL'|'EVM';

type OnConnect= (param: { type: OnConnectType; provider: TonProvider | EthereumProvider }) => any

export type initTomoModalParams = Omit<TomoProviderProps, 'children'> & {
  onConnect?: OnConnect;
};

export function Seamless({
  onConnect,
  resolve,
  ...restProps
}: initTomoModalParams & {
  resolve: (value: unknown) => void;
}) {
  const [ColorScheme] = useThemeParams();

  return (
    <TomoProvider theme={ColorScheme} {...restProps}>
      <Dummy onConnect={onConnect} onMounted={resolve} />
    </TomoProvider>
  );
}

export function Dummy({
  onConnect,
  onMounted,
}: {
  onConnect: OnConnect;
  onMounted: (value: unknown) => void;
}) {
  const { openConnectModal, providers, connectResult } = useTomo();

  useEffect(() => {
    (window as any).openTomoConnectModal = openConnectModal;
    onMounted(true);
  }, [openConnectModal]);

  useEffect(() => {
    console.log('connectResult>>>>>>>:', connectResult);
  }, [connectResult]);

  useEffect(() => {
    const tomo_ton = providers.tomo_ton;
    if (tomo_ton?.connected && tomo_ton?.account) {
      onConnect({
        type: 'TON',
        provider: providers.tomo_ton as any
      });
    }
  }, [
    providers.tomo_ton,
    providers.tomo_ton?.connected,
    providers.tomo_ton?.account,
  ]);

  useEffect(() => {
    const ethereum = providers.ethereum;
    if (ethereum) {
      onConnect({
        type: 'EVM',
        provider: ethereum,
      });
    }
  }, [
    providers.ethereum,
  ]);
  return <></>;
}

export function initTomoModal({
  onConnect = () => {},
  ...restProps
}: initTomoModalParams) {
  const div = document.createElement('div');
  div.id = 'tomo-seamless-modal';
  document.body.appendChild(div);
  return new Promise(resolve => {
    ReactDOM.render(
      <Seamless onConnect={onConnect} resolve={resolve} {...restProps} />,
      div
    );
  });
}
